import { useState } from "react";

import { buildContext } from "@vega-core/helpers/context/buildContext";

function useModalSize() {
  const [isWide, setWide] = useState(false);

  return { isWide, setWide };
}

export const {
  ContextProvider: ModalSizeProvider,
  useContext: useModalSizeContext,
} = buildContext(useModalSize);
